import { useEffect } from 'react';

// Fades in every [data-reveal] element, like a photo developing, as it scrolls into view.
export default function useReveal() {
    useEffect(() => {
        const els = [...document.querySelectorAll('[data-reveal]')];
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (reduceMotion || !('IntersectionObserver' in window) || !Element.prototype.animate) {
            els.forEach(el => { el.style.opacity = 1; });
            return;
        }

        const reveal = (el, i) => el.animate([
            { opacity: 0, transform: 'translateY(28px)', filter: 'sepia(1) blur(4px) contrast(.6)' },
            { opacity: 1, transform: 'none', filter: 'none' }
        ], { duration: 1100, delay: (i % 3) * 120, easing: 'cubic-bezier(.2,.8,.2,1)', fill: 'forwards' });

        const io = new IntersectionObserver(entries => {
            entries.forEach(e => {
                if (e.isIntersecting) {
                    reveal(e.target, els.indexOf(e.target));
                    io.unobserve(e.target);
                }
            });
        }, { threshold: 0.12 });

        els.forEach(el => io.observe(el));
        return () => io.disconnect();
    }, []);
}
